// Sends a visitor message two ways: email (EmailJS) and the /admin inbox (pf_contact).
// Either one succeeding counts as sent. Used by the contact form and the chat.

async function saveMessage(m) {
  const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/rest/v1/rpc/pf_contact`, {
    method: 'POST',
    headers: {
      apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ p_name: m.from_name, p_email: m.from_email, p_subject: m.subject, p_message: m.message }),
  });
  if (!res.ok) throw new Error(`Could not save message (HTTP ${res.status})`);
}

export async function sendContact(formData) {
  const results = await Promise.allSettled([
    import('@emailjs/browser').then(({ default: emailjs }) => emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formData,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )),   // loaded only when someone sends a message
    saveMessage(formData),
  ]);
  if (results.every((r) => r.status === 'rejected')) throw results[0].reason;
}
